import { Reveal, SectionHeading } from "./Reveal";

const STEPS = [
  {
    n: "01",
    title: "Cleanse",
    copy: "Start with a clean, dry face. Gently pat the under-eye area dry so the patches adhere beautifully.",
    img: "https://images.pexels.com/photos/5313589/pexels-photo-5313589.jpeg",
    alt: "Woman applying an under-eye patch to clean skin",
  },
  {
    n: "02",
    title: "Apply",
    copy: "Place one patch beneath each eye, smoothing from the inner corner outwards. Wear for 15–20 minutes.",
    img: "/assets/ritual-cleanse.webp",
    alt: "Woman wearing gold hydrogel under-eye patches",
  },
  {
    n: "03",
    title: "Relax",
    copy: "Remove the patches and gently massage any remaining serum into the skin. No rinsing needed.",
    img: "/assets/ritual-relax.webp",
    alt: "Woman relaxing with gold under-eye patches on a towel",
  },
];

export const HowItWorks = () => (
  <section id="how-it-works" className="py-24 md:py-32 bg-white" data-testid="how-it-works-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <SectionHeading
        eyebrow="The Ritual"
        title={<>Three steps to <span className="italic gold-text">golden hour</span></>}
        copy="A simple, calming routine that fits around your day — no appointment required."
      />
      <div className="mt-20 space-y-20 md:space-y-28">
        {STEPS.map((s, i) => (
          <div
            key={s.n}
            className={`grid md:grid-cols-2 gap-10 md:gap-16 items-center ${i % 2 === 1 ? "md:[&>*:first-child]:order-2" : ""}`}
          >
            <Reveal>
              <div className="relative">
                <span className="font-display italic text-[7rem] md:text-[9rem] leading-none text-champagne select-none" aria-hidden>
                  {s.n}
                </span>
                <div className="-mt-12 md:-mt-16 relative">
                  <h3 className="font-display text-3xl md:text-4xl text-ink">{s.title}</h3>
                  <p className="mt-4 max-w-md text-base text-[#5C5C5C] leading-relaxed">{s.copy}</p>
                </div>
              </div>
            </Reveal>
            <Reveal delay={0.12}>
              <div className="overflow-hidden rounded-[2rem] border border-champagne/70 shadow-[0_24px_60px_rgb(0,0,0,0.06)]">
                <img
                  src={s.img}
                  alt={s.alt}
                  loading="lazy"
                  data-testid={`how-it-works-image-${s.n}`}
                  className="w-full aspect-[4/3] object-cover transition-transform duration-700 ease-out hover:scale-105"
                />
              </div>
            </Reveal>
          </div>
        ))}
      </div>
    </div>
  </section>
);
